module.exports = __webpack_public_path__ + "23_cikm_1.jpg?c4c6bdd00154685b9241a7d39db2cbc1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_cikm_1.jpg
// module id = 196
// module chunks = 0